export class PaymentProviderPayMethodRequestModel {
  constructor(public cinemaId: string, public orderId: string, public paymentProvider: string, public paymentChannel?: string) {}
}
